import { InjectionToken } from '@angular/core';
import { GridDataSources, GridFilterService, GridService, ReaderService, UserAccessService } from './types';

export const DATA_GRID_SERVICES: InjectionToken<GridService<unknown>> = new InjectionToken<GridService<unknown>>(
  'DATA_GRID_SERVICES',
);

export const DATA_GRID_DATA_SOURCES: InjectionToken<GridDataSources<unknown, unknown>> = new InjectionToken<
  GridDataSources<unknown, unknown>
>('DATA_GRID_DATA_SOURCES');

export const DATA_GRID_FILTER_SERVICE: InjectionToken<GridFilterService<unknown>> = new InjectionToken<
  GridFilterService<unknown>
>('DATA_GRID_FILTER_SERVICE');

export const DATA_GRID_READER_SERVICE: InjectionToken<ReaderService<unknown>> = new InjectionToken<
  ReaderService<unknown>
>('DATA_GRID_READER_SERVICE');

export const DATA_GRID_CURRENT_ACCESS_SERVICE: InjectionToken<UserAccessService> =
  new InjectionToken<UserAccessService>('DATA_GRID_CURRENT_ACCESS_SERVICE');
